import { dateUtils, type Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import cx from 'classnames'

import type { TemplateVersionInfo } from '../../types/templateModel'

type Props = {
  versionInfo: Optional<TemplateVersionInfo>
  isFirstShadowedVersion: boolean
}

export const ShadowedVersionTitle = ({
  versionInfo,
  isFirstShadowedVersion,
}: Props) => {
  const translate = useTranslate()
  return (
    <div
      className={cx(
        'text-warning-500 dark:text-warning-300',
        isFirstShadowedVersion ? 'font-bold' : 'opacity-50',
      )}
    >{`${translate('templateViewer.previousVersionDiffSelector.shadowed')} ${dateUtils.dateAsStr(versionInfo?.fromDate)}`}</div>
  )
}
